




































import { Component, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import JobWorkerOfferStatusSetCancelled from '@/components/JobWorkerOffers/JobWorkerOfferStatusSetCancelled.vue';
import JobWorkerOfferStatusSetContactDeclined from '@/components/JobWorkerOffers/JobWorkerOfferStatusSetContactDeclined.vue';
import JobWorkerOfferStatusSetWorkerDeclined from '@/components/JobWorkerOffers/JobWorkerOfferStatusSetWorkerDeclined.vue';
import JobWorkerOfferStatusSetPlaced from '@/components/JobWorkerOffers/JobWorkerOfferStatusSetPlaced.vue';
import JobWorkerOfferDto from '@/models/JobWorkerOffers/JobWorkerOfferDto';
import JobWorkerStatus from '@/models/JobWorkers/JobWorkerStatus';
import JobWorkerOfferStatus from '@/models/JobWorkerOffers/JobWorkerOfferStatus';
import SendJobWorkerOfferToWorkerRequest from '@/models/JobWorkerOffers/SendJobWorkerOfferToWorkerRequest';
import UpdateJobWorkerOfferContactConfirmationRequest from '@/models/JobWorkerOffers/UpdateJobWorkerOfferContactConfirmationRequest';
import UpdateJobWorkerOfferWorkerAcceptanceRequest from '@/models/JobWorkerOffers/UpdateJobWorkerOfferWorkerAcceptanceRequest';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
    name: 'JobWorkerOfferStatusSet',
    components: { JobWorkerOfferStatusSetCancelled, JobWorkerOfferStatusSetPlaced, JobWorkerOfferStatusSetContactDeclined, JobWorkerOfferStatusSetWorkerDeclined }
})
export default class extends GiganautVueDialog {
 
  jobWorkerOfferStatus = JobWorkerOfferStatus;

  @Prop({required: true})
  jobWorkerOffer: JobWorkerOfferDto;
  @Prop({required: true})
  jobWorkerStatus: JobWorkerStatus;
  menu = false;

  get disabled() {
    return this.jobWorkerStatus !== JobWorkerStatus.Offer;
	}

  get showPlaced() {
    if (JobDetailsModule.currentJob.headcount > JobDetailsModule.currentJob.workersPlaced) {
      if (this.jobWorkerOffer.status === JobWorkerOfferStatus.WorkerAccepted) {
        return true;
      }
    }
    return false;
  }

  get showCancelled() {
    if (this.jobWorkerOffer.status !== JobWorkerOfferStatus.Cancelled && this.jobWorkerOffer.status !== JobWorkerOfferStatus.WorkerAccepted && this.jobWorkerOffer.status !== JobWorkerOfferStatus.Placed) {
      return true
    }
    return false;
  }

  get showWorkerAccepted() {
    if (this.jobWorkerOffer.status === JobWorkerOfferStatus.SentToWorker || this.jobWorkerOffer.status === JobWorkerOfferStatus.WorkerDeclined){
      return true;
    }
    return false;
  }

  get showWorkerDeclined() {
    if (this.jobWorkerOffer.status === JobWorkerOfferStatus.SentToWorker || this.jobWorkerOffer.status === JobWorkerOfferStatus.WorkerAccepted){
      return true;
    }
    return false;
  }

  get showContactConfirmed() {
    if (this.jobWorkerOffer.status === JobWorkerOfferStatus.Pending || this.jobWorkerOffer.status === JobWorkerOfferStatus.SentToContact || this.jobWorkerOffer.status === JobWorkerOfferStatus.ContactDeclined){
      return true;
    }
    return false;
  }

  get showContactDeclined() {
    if (this.jobWorkerOffer.status === JobWorkerOfferStatus.Pending || this.jobWorkerOffer.status === JobWorkerOfferStatus.SentToContact || this.jobWorkerOffer.status === JobWorkerOfferStatus.ContactConfirmed){
      return true;
    }
    return false;
  }

  get showSendToWorker() {
    if (this.jobWorkerOffer.status === JobWorkerOfferStatus.ContactConfirmed){
      return true;
    }
    return false;
  }

  async setStatusToWorkerAccepted() {
    const request = new UpdateJobWorkerOfferWorkerAcceptanceRequest();
    request.jobWorkerOfferId = this.jobWorkerOffer.id;
    request.updatedAt = this.jobWorkerOffer.updatedAt;
    request.accepted = true;
    await JobDetailsModule.updateJobWorkerOfferWorkerAcceptance(request);
  }

  async setStatusToSentToWorker() {
        const options: VuetifyConfirmObject = {
      buttonTrueText: "SEND",
      buttonFalseText: "CANCEL",
      buttonTrueColor: "primary",
      buttonFalseColor: "primary",
    };
    const result = await this.$confirm(
      "Are you sure you want to send this offer to the " + this.Labels.worker.toLowerCase() + "?",
      options
    );
    if (result) {
      const request = new SendJobWorkerOfferToWorkerRequest();
      request.jobWorkerOfferId = this.jobWorkerOffer.id;
      request.updatedAt = this.jobWorkerOffer.updatedAt;
      await JobDetailsModule.sendJobWorkerOfferToWorker(request);
    }
  }

  async setStatusToContactConfirmed() {
    const request = new UpdateJobWorkerOfferContactConfirmationRequest();
    request.jobWorkerOfferId = this.jobWorkerOffer.id;
    request.updatedAt = this.jobWorkerOffer.updatedAt;
    request.confirmed = true;
    await JobDetailsModule.updateJobWorkerOfferContactConfirmation(request);
  }
}
